<template>
  <v-autocomplete
    :value="value"
    name="person_id"
    item-value="id"
    item-text="full_name"
    :items="persons"
    :search-input.sync="search"
    :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
    :label="`${$t('CONTACT_PERSONS.ITEM')} *`"
    clearable
    v-bind="$attrs"
    v-on="listeners"
  />
</template>

<script>
import { debounce } from 'lodash';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'SelectPerson',

  mixins: [i18nRefreshData],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Number,
      default: null
    },
    delay: {
      type: Number,
      default: 500
    }
  },

  data: () => ({
    search: '',
    debounced: null,
    persons: []
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        change: [this.clearSearch, this.emitter],
        'click:clear': this.clearFilter
      });
    }
  },

  watch: {
    search(newVal, oldVal) {
      if (newVal && newVal !== oldVal && newVal !== this.value) {
        this.debounced();
      }
    }
  },

  created() {
    this.debounced = debounce(this.getPersons, this.delay);
  },

  methods: {
    ...mapCacheActions('person', ['getFilteredPersons']),

    clearSearch() {
      this.search = '';
    },

    clearFilter() {
      this.emitter('');
    },

    emitter(data) {
      this.$emit('input', data);
      this.$emit('change', data);
    },

    refreshData() {
      if (this.search) {
        this.getPersons();
      }
    },

    getPersons() {
      this.getFilteredPersons({ search: this.search })
        .then(({ data }) => {
          this.persons = data.data;
        })
        .catch(({ response }) => {
          this.$emit('error-response', response);
        });
    }
  }
};
</script>
